import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "resources-home-view" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-main" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "view-toggle" }
const _hoisted_6 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_7 = { class: "search-box" }
const _hoisted_8 = { class: "resource-actions" }
const _hoisted_9 = {
  key: 0,
  class: "dashboard-view"
}
const _hoisted_10 = { class: "dashboard-container" }
const _hoisted_11 = { class: "dashboard-header" }
const _hoisted_12 = { class: "dashboard-grid" }
const _hoisted_13 = { class: "stat-header" }
const _hoisted_14 = { class: "stat-content" }
const _hoisted_15 = { class: "stat-number" }
const _hoisted_16 = { class: "stat-trend" }
const _hoisted_17 = { class: "stat-header" }
const _hoisted_18 = { class: "stat-content" }
const _hoisted_19 = { class: "stat-number" }
const _hoisted_20 = { class: "stat-trend" }
const _hoisted_21 = { class: "stat-header" }
const _hoisted_22 = { class: "stat-content" }
const _hoisted_23 = { class: "stat-number" }
const _hoisted_24 = { class: "stat-trend" }
const _hoisted_25 = { class: "stat-header" }
const _hoisted_26 = { class: "stat-content" }
const _hoisted_27 = { class: "stat-number" }
const _hoisted_28 = { class: "stat-subtitle" }
const _hoisted_29 = { class: "chart-header" }
const _hoisted_30 = { class: "chart-content" }
const _hoisted_31 = { class: "chart-content" }
const _hoisted_32 = {
  key: 1,
  class: "company-list-container"
}
const _hoisted_33 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_34 = { class: "company-card-skeleton" }
const _hoisted_35 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_36 = {
  key: 2,
  class: "company-list"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "company-info" }
const _hoisted_39 = { class: "company-logo" }
const _hoisted_40 = { class: "company-details" }
const _hoisted_41 = { class: "company-name" }
const _hoisted_42 = { class: "company-meta" }
const _hoisted_43 = {
  key: 0,
  class: "company-location"
}
const _hoisted_44 = {
  key: 1,
  class: "company-industry"
}
const _hoisted_45 = { class: "company-actions" }
const _hoisted_46 = { class: "status-tags" }
const _hoisted_47 = { class: "interaction-icons" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "pagination-container" }
const _hoisted_52 = { class: "dialog-footer" }

import { ref, onMounted, reactive, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { 
  Plus, 
  Star, 
  Top, 
  Search, 
  Location, 
  OfficeBuilding,
  ArrowRight,
  Office,
  Suitcase,
  Files,
  Calendar,
  Document,
  Timer,
  Grid,
  DataBoard,
  Refresh
} from '@element-plus/icons-vue';
import { useCompanyStore } from '@/store/companyStore';
import type { Company } from '@/types/company';
import CompanyForm from '@/components/company/CompanyForm.vue';
import { ElMessage } from 'element-plus';
import { usePositionStore } from '@/store/positionStore';
import interviewService from '@/services/interviewService';
import type { Interview } from '@/types/interview';
import { INTERVIEW_STAGES } from '@/types/interview';
import type { Position } from '@/types/position';
import * as echarts from 'echarts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourcesHomeView',
  setup(__props) {

const router = useRouter();
const companyStore = useCompanyStore();
const positionStore = usePositionStore();
const searchText = ref('');
const addDialogVisible = ref(false);
const addFormRef = ref();

// 存储公司的面试状态
const companyInterviewStatus = ref<Map<number, { 
  status: string; 
  position: string;
  stage: string | null;
}>>(new Map());

// 修改颜色映射对象
const STAGE_TYPES = {
  'not_started': 'info',       // 未开始 - 灰色
  'online_test': 'warning',    // 在线测试 - 橙色
  'first_round': 'primary',    // 第一轮 - 蓝色
  'second_round': 'success',   // 第二轮 - 绿色
  'final_round': 'danger',     // 终面 - 红色
  'hr_round': 'warning',       // HR面 - 橙色
  'completed': 'success',      // 已完成 - 绿色
  'applying': 'info'           // 投递中 - 灰色
};

const STAGE_LABELS = {
  'not_started': '待面试',
  'online_test': '在线测试',
  'first_round': '第一轮',
  'second_round': '第二轮',
  'final_round': '终面',
  'hr_round': 'HR面',
  'completed': '已完成',
  'applying': '投递中'
};

// 获取公司的面试状态
const getCompanyInterviewStatus = async (company: Company) => {
  if (!company.id) return;
  
  try {
    // 获取公司的所有职位
    await positionStore.getPositionsByCompany(company.id, 1);
    const positions = positionStore.positions;
    
    if (positions.length === 0) {
      return;
    }

    let latestInterview: Interview | null = null;
    let latestPosition: Position | null = null;
    
    // 遍历所有职位获取面试记录
    for (const position of positions) {
      if (position.id) {
        try {
          const response = await interviewService.getInterviewsByPosition(position.id);
          let interviews: Interview[] = [];
          
          if (response && response.content && Array.isArray(response.content)) {
            interviews = response.content;
          } else if (Array.isArray(response)) {
            interviews = response;
          }
          
          if (interviews.length > 0) {
            // 按时间排序，找出最近的面试
            const sortedInterviews = [...interviews].sort((a, b) => {
              const now = new Date().getTime();
              const diffA = Math.abs(new Date(a.dateTime).getTime() - now);
              const diffB = Math.abs(new Date(b.dateTime).getTime() - now);
              return diffA - diffB;
            });
            
            // 如果这是最近的面试，更新状态
            if (!latestInterview || 
                Math.abs(new Date(sortedInterviews[0].dateTime).getTime() - new Date().getTime()) <
                Math.abs(new Date(latestInterview.dateTime).getTime() - new Date().getTime())) {
              latestInterview = sortedInterviews[0];
              latestPosition = position;
            }
          }
        } catch (error) {
          console.error(`获取职位 ${position.id} 的面试记录失败:`, error);
        }
      }
    }
    
    // 更新公司的面试状态
    if (latestInterview && latestPosition) {
      const stageLabel = STAGE_LABELS[latestInterview.stage as keyof typeof STAGE_LABELS] || '未知状态';
      companyInterviewStatus.value.set(company.id, {
        status: `${stageLabel}(${latestPosition.title})`,
        position: latestPosition.title || '',
        stage: latestInterview.stage
      });
    } else {
      companyInterviewStatus.value.set(company.id, {
        status: STAGE_LABELS.applying,
        position: '',
        stage: 'applying'
      });
    }
  } catch (error) {
    console.error('获取公司面试状态失败:', error);
  }
};

// 页面加载时获取公司列表
onMounted(async () => {
  await companyStore.queryCompanies({});
  // 获取每个公司的面试状态
  for (const company of companyStore.companies) {
    await getCompanyInterviewStatus(company);
  }
});

// 打开添加对话框
const openAddDialog = () => {
  addDialogVisible.value = true;
};

// 提交添加表单
const submitAddForm = () => {
  if (addFormRef.value) {
    addFormRef.value.submitForm();
  }
};

// 处理添加公司
const handleAddCompany = async (company: Company) => {
  try {
    await companyStore.createCompany(company);
    addDialogVisible.value = false;
    
    // 重新加载列表
    if (searchText.value.trim()) {
      await companyStore.searchCompanies({ keyword: searchText.value.trim() });
    } else {
      await companyStore.queryCompanies({});
    }
  } catch (error) {
    console.error('添加公司失败:', error);
  }
};

// 处理行点击
const handleRowClick = (company: Company) => {
  if (company.id) {
    router.push(`/resources/companies/${company.id}`);
  }
};

// 处理公司点击
const handleCompanyClick = (company: Company) => {
  if (company.id) {
    router.push(`/resources/companies/${company.id}`);
  }
};

// 处理搜索
const handleSearch = async () => {
  if (searchText.value.trim()) {
    await companyStore.searchCompanies({ 
      keyword: searchText.value.trim()
    });
  } else {
    await companyStore.queryCompanies({});
  }
  
  // 重新获取面试状态
  companyInterviewStatus.value.clear();
  for (const company of companyStore.companies) {
    await getCompanyInterviewStatus(company);
  }
};

// 处理分页大小变化
const handleSizeChange = async (size: number) => {
  companyStore.size = size;
  if (searchText.value.trim()) {
    await companyStore.searchCompanies({ 
      keyword: searchText.value.trim()
    });
  } else {
    await companyStore.queryCompanies({});
  }
};

// 处理页码变化
const handlePageChange = async (page: number) => {
  companyStore.page = page;
  if (searchText.value.trim()) {
    await companyStore.searchCompanies({ 
      keyword: searchText.value.trim() 
    });
  } else {
    await companyStore.queryCompanies({});
  }
};

const handlePositionClick = (company: Company) => {
  router.push(`/resources/companies/${company.id}#positions`);
};

const handleResourceClick = (company: Company) => {
  router.push(`/resources/companies/${company.id}#resources`);
};

const handleInterviewClick = (company: Company) => {
  router.push(`/resources/companies/${company.id}#interviews`);
};

// 视图切换状态
const currentView = ref('list');
const trendTimeRange = ref('week');
const trendChartRef = ref<HTMLElement | null>(null);
const statusChartRef = ref<HTMLElement | null>(null);

// 仪表盘数据
const dashboardStats = reactive({
  submittedCompanies: 0,
  companyTrend: 0,
  totalInterviews: 0,
  interviewTrend: 0,
  totalPositions: 0,
  positionTrend: 0,
  totalDays: 0,
  startDate: '',
  recentEvents: [] as Array<{
    id: number;
    time: string;
    content: string;
    type: 'primary' | 'success' | 'warning' | 'danger' | 'info';
  }>
});

// 添加刷新状态
const refreshing = ref(false);

// 处理仪表盘刷新
const handleRefreshDashboard = async () => {
  refreshing.value = true;
  try {
    await fetchDashboardData();
    ElMessage.success('数据已更新');
  } catch (error) {
    console.error('刷新仪表盘失败:', error);
    ElMessage.error('刷新失败，请重试');
  } finally {
    refreshing.value = false;
  }
};

// 获取仪表盘数据
const fetchDashboardData = async () => {
  try {
    // 初始化图表实例
    const trendChart = trendChartRef.value ? echarts.init(trendChartRef.value) : null;
    const statusChart = statusChartRef.value ? echarts.init(statusChartRef.value) : null;

    // 获取所有公司数据
    const response = await companyStore.queryCompanies({});
    console.log('Dashboard query response:', response);
    console.log('Company store state after query:', {
      companies: companyStore.companies,
      total: companyStore.total,
      page: companyStore.page,
      size: companyStore.size
    });
    
    if (!Array.isArray(companyStore.companies)) {
      console.error('Companies data is not an array:', companyStore.companies);
      ElMessage.error('获取公司数据格式错误');
      return;
    }

    // 统计已投递的公司数量（排除计划投递状态）
    const submittedCompanies = companyStore.companies.length;  // 先显示总数
    console.log('Total companies count:', submittedCompanies);

    // 按状态统计
    const statusCounts = {
      planned: companyStore.companies.filter(c => c.status === 'planned').length,
      submitted: companyStore.companies.filter(c => c.status === 'submitted').length,
      interviewing: companyStore.companies.filter(c => c.status === 'interviewing').length,
      offered: companyStore.companies.filter(c => c.status === 'offered').length,
      rejected: companyStore.companies.filter(c => c.status === 'rejected').length,
      accepted: companyStore.companies.filter(c => c.status === 'accepted').length
    };
    console.log('Status counts:', statusCounts);

    // 更新仪表盘数据
    dashboardStats.submittedCompanies = submittedCompanies;
    dashboardStats.companyTrend = 0; // 暂时设为0

    // 获取面试数量
    let totalInterviews = 0;
    for (const company of companyStore.companies) {
      if (company.id) {
        try {
          // 获取公司的所有职位
          await positionStore.getPositionsByCompany(company.id, 1);
          const positions = positionStore.positions;
          
          // 遍历所有职位获取面试记录
          for (const position of positions) {
            if (position.id) {
              try {
                const response = await interviewService.getInterviewsByPosition(position.id);
                let interviews: Interview[] = [];
                
                if (response && response.content && Array.isArray(response.content)) {
                  interviews = response.content;
                } else if (Array.isArray(response)) {
                  interviews = response;
                }
                
                totalInterviews += interviews.length;
              } catch (error) {
                console.error(`获取职位 ${position.id} 的面试记录失败:`, error);
              }
            }
          }
        } catch (error) {
          console.error(`获取公司 ${company.id} 的职位失败:`, error);
        }
      }
    }

    console.log('Total interviews:', totalInterviews);
    dashboardStats.totalInterviews = totalInterviews;
    dashboardStats.interviewTrend = 0; // 暂时设为0
    dashboardStats.totalPositions = companyStore.companies.reduce((sum, company) => sum + (company.positionCount || 0), 0);
    dashboardStats.positionTrend = 0; // 暂时设为0

    // 获取第一条投递记录的时间作为开始时间
    const sortedCompanies = [...companyStore.companies].sort((a, b) => {
      const dateA = new Date(a.createTime || '');
      const dateB = new Date(b.createTime || '');
      return dateA.getTime() - dateB.getTime();
    });

    console.log('Sorted companies:', sortedCompanies.map(c => ({
      name: c.name,
      createTime: c.createTime,
      status: c.status
    })));

    if (sortedCompanies.length > 0 && sortedCompanies[0].createTime) {
      const startDate = new Date(sortedCompanies[0].createTime);
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      dashboardStats.totalDays = diffDays;
      dashboardStats.startDate = startDate.toLocaleDateString('zh-CN');
      console.log('Dashboard stats updated:', dashboardStats);
    } else {
      dashboardStats.totalDays = 0;
      dashboardStats.startDate = '-';
      console.log('No valid company dates found');
    }

    // 更新状态分布图表
    if (statusChart) {
      const statusData = [
        { 
          value: statusCounts.planned,
          name: '计划投递'
        },
        { 
          value: statusCounts.submitted,
          name: '已投递'
        },
        { 
          value: statusCounts.interviewing,
          name: '面试中'
        },
        { 
          value: statusCounts.offered,
          name: '已收到offer'
        },
        { 
          value: statusCounts.rejected,
          name: '已拒绝'
        },
        { 
          value: statusCounts.accepted,
          name: '已接受'
        }
      ].filter(item => item.value > 0);

      console.log('Status chart data:', statusData);

      // 如果没有数据，显示空状态
      if (statusData.length === 0) {
        statusData.push({
          value: 1,
          name: '暂无数据'
        });
      }

      statusChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          padding: 5,
          itemGap: 10,
          textStyle: {
            fontSize: 12
          }
        },
        series: [{
          type: 'pie',
          radius: '50%',
          data: statusData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: true,
            formatter: '{b}: {c}'
          }
        }]
      });
    }

    // 更新投递趋势图表
    if (trendChart) {
      const today = new Date();
      const dates = [];
      const counts = [];
      const trendData = new Map(); // 用于存储每天的投递数量

      // 根据选择的时间范围生成日期
      let days = 7;
      if (trendTimeRange.value === 'month') {
        days = 30;
      } else if (trendTimeRange.value === 'year') {
        days = 365;
      }

      // 初始化日期范围内的所有日期
      for (let i = days - 1; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toLocaleDateString('zh-CN');
        dates.push(dateStr);
        trendData.set(dateStr, 0);
      }

      // 统计每天的投递数量
      companyStore.companies.forEach(company => {
        if (company.createTime) {
          const createDate = new Date(company.createTime);
          const dateStr = createDate.toLocaleDateString('zh-CN');
          if (trendData.has(dateStr)) {
            trendData.set(dateStr, trendData.get(dateStr)! + 1);
          }
        }
      });

      // 生成最终的计数数组
      counts.push(...dates.map(date => trendData.get(date) || 0));

      console.log('Trend chart data:', { dates, counts });

      // 计算上周期的数据用于计算趋势
      const currentPeriodTotal = counts.reduce((sum, count) => sum + count, 0);
      const previousPeriodCounts = [];
      for (let i = days * 2 - 1; i >= days; i--) {
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toLocaleDateString('zh-CN');
        const count = companyStore.companies.filter(company => {
          if (!company.createTime) return false;
          const companyDate = new Date(company.createTime);
          return companyDate.toLocaleDateString('zh-CN') === dateStr;
        }).length;
        previousPeriodCounts.push(count);
      }
      const previousPeriodTotal = previousPeriodCounts.reduce((sum, count) => sum + count, 0);

      // 计算趋势百分比
      if (previousPeriodTotal > 0) {
        const trend = ((currentPeriodTotal - previousPeriodTotal) / previousPeriodTotal) * 100;
        dashboardStats.companyTrend = Math.round(trend);
      }

      trendChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br />投递数量: {c}'
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            rotate: 45,
            interval: Math.floor(days / 7)
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [{
          data: counts,
          type: 'line',
          smooth: true,
          name: '投递数量',
          itemStyle: {
            color: '#409EFF'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(64,158,255,0.3)' },
              { offset: 1, color: 'rgba(64,158,255,0.1)' }
            ])
          }
        }]
      });
    }

    // 生成事件时间线
    const events: Array<{
      id: number;
      time: string;
      content: string;
      type: 'primary' | 'success' | 'warning' | 'danger' | 'info';
    }> = [];

    // 收集所有事件
    const allEvents = [];

    // 添加公司创建事件
    companyStore.companies.forEach(company => {
      if (company.createTime) {
        allEvents.push({
          time: new Date(company.createTime),
          content: `添加了公司 ${company.name}`,
          type: 'primary' as const
        });
      }
    });

    // 添加面试事件
    for (const company of companyStore.companies) {
      if (company.id) {
        const positions = positionStore.positions;
        for (const position of positions) {
          if (position.id) {
            try {
              const response = await interviewService.getInterviewsByPosition(position.id);
              let interviews: Interview[] = [];
              
              if (response && response.content && Array.isArray(response.content)) {
                interviews = response.content;
              } else if (Array.isArray(response)) {
                interviews = response;
              }
              
              interviews.forEach(interview => {
                allEvents.push({
                  time: new Date(interview.dateTime),
                  content: `${company.name} - ${position.title} ${STAGE_LABELS[interview.stage as keyof typeof STAGE_LABELS]}面试`,
                  type: 'warning' as const
                });
              });
            } catch (error) {
              console.error(`获取面试记录失败:`, error);
            }
          }
        }
      }
    }

    // 排序所有事件（按时间倒序）
    allEvents.sort((a, b) => b.time.getTime() - a.time.getTime());

    // 取最近的10个事件
    dashboardStats.recentEvents = allEvents.slice(0, 10).map((event, index) => ({
      id: index + 1,
      time: event.time.toLocaleString('zh-CN'),
      content: event.content,
      type: event.type
    }));

    console.log('Recent events:', dashboardStats.recentEvents);

  } catch (error) {
    console.error('获取仪表盘数据失败:', error);
    ElMessage.error('获取数据失败，请稍后重试');
  }
};

onMounted(() => {
  fetchDashboardData();
});

// 监听时间范围变化
watch(trendTimeRange, () => {
  fetchDashboardData();
});

// 在组件卸载时清理图表实例
onUnmounted(() => {
  if (trendChartRef.value) {
    echarts.dispose(trendChartRef.value);
  }
  if (statusChartRef.value) {
    echarts.dispose(statusChartRef.value);
  }
});

// 添加跳转到极简版的方法
const goToSimpleVersion = () => {
  router.push('/resources/simple');
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_company_status_tag = _resolveComponent("company-status-tag")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "page-title" }, "资源管理", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "page-description" }, "管理您的求职相关资源", -1)),
          _createVNode(_component_el_button, {
            type: "info",
            size: "small",
            class: "simple-mode-btn",
            onClick: goToSimpleVersion
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" 切换极简版 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_radio_group, {
            modelValue: currentView.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentView).value = $event)),
            size: "large",
            class: "custom-radio-group"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "list" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Grid))
                    ]),
                    _: 1
                  }),
                  _cache[10] || (_cache[10] = _createTextVNode(" 列表视图 "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "dashboard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DataBoard))
                    ]),
                    _: 1
                  }),
                  _cache[11] || (_cache[11] = _createTextVNode(" 仪表盘 "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      (currentView.value === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                placeholder: "搜索公司...",
                clearable: "",
                class: "rounded-search",
                onClear: handleSearch
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "search-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                circle: "",
                plain: "",
                class: "search-action-button",
                onClick: handleSearch,
                title: "搜索"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: openAddDialog
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[12] || (_cache[12] = _createTextVNode(" 添加公司 "))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (currentView.value === 'dashboard')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "dashboard-title" }, "数据概览", -1)),
              _createVNode(_component_el_button, {
                loading: refreshing.value,
                circle: "",
                onClick: handleRefreshDashboard,
                class: "refresh-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Refresh))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_row, {
                gutter: 20,
                class: "stat-cards"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "stat-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Suitcase))
                              ]),
                              _: 1
                            }),
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "已投递公司", -1))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(dashboardStats.submittedCompanies), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _cache[15] || (_cache[15] = _createTextVNode(" 较上周 ")),
                              _createElementVNode("span", {
                                class: _normalizeClass({'trend-up': dashboardStats.companyTrend > 0})
                              }, _toDisplayString(dashboardStats.companyTrend > 0 ? '+' : '') + _toDisplayString(dashboardStats.companyTrend) + "% ", 3)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "stat-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Calendar))
                              ]),
                              _: 1
                            }),
                            _cache[16] || (_cache[16] = _createElementVNode("span", null, "面试数量", -1))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(dashboardStats.totalInterviews), 1),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[17] || (_cache[17] = _createTextVNode(" 较上周 ")),
                              _createElementVNode("span", {
                                class: _normalizeClass({'trend-up': dashboardStats.interviewTrend > 0})
                              }, _toDisplayString(dashboardStats.interviewTrend > 0 ? '+' : '') + _toDisplayString(dashboardStats.interviewTrend) + "% ", 3)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "stat-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Document))
                              ]),
                              _: 1
                            }),
                            _cache[18] || (_cache[18] = _createElementVNode("span", null, "投递职位", -1))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(dashboardStats.totalPositions), 1),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[19] || (_cache[19] = _createTextVNode(" 较上周 ")),
                              _createElementVNode("span", {
                                class: _normalizeClass({'trend-up': dashboardStats.positionTrend > 0})
                              }, _toDisplayString(dashboardStats.positionTrend > 0 ? '+' : '') + _toDisplayString(dashboardStats.positionTrend) + "% ", 3)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "stat-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Timer))
                              ]),
                              _: 1
                            }),
                            _cache[20] || (_cache[20] = _createElementVNode("span", null, "求职天数", -1))
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(dashboardStats.totalDays), 1),
                            _createElementVNode("div", _hoisted_28, "开始于 " + _toDisplayString(dashboardStats.startDate), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                gutter: 20,
                class: "chart-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "chart-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_29, [
                            _cache[24] || (_cache[24] = _createElementVNode("span", null, "投递趋势", -1)),
                            _createVNode(_component_el_radio_group, {
                              modelValue: trendTimeRange.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((trendTimeRange).value = $event)),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_button, { label: "week" }, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode("周")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio_button, { label: "month" }, {
                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                    _createTextVNode("月")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio_button, { label: "year" }, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("年")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", {
                              ref_key: "trendChartRef",
                              ref: trendChartRef,
                              style: {"height":"300px"}
                            }, null, 512)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "chart-card" }, {
                        header: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("div", { class: "chart-header" }, [
                            _createElementVNode("span", null, "公司状态分布")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", {
                              ref_key: "statusChartRef",
                              ref: statusChartRef,
                              style: {"height":"300px"}
                            }, null, 512)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "timeline-card" }, {
                        header: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createElementVNode("div", { class: "timeline-header" }, [
                            _createElementVNode("span", null, "求职事件时间线")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createVNode(_component_el_timeline, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardStats.recentEvents, (event) => {
                                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                  key: event.id,
                                  timestamp: event.time,
                                  type: event.type
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(event.content), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["timestamp", "type"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (_unref(companyStore).loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_el_skeleton, {
                  rows: 3,
                  animated: ""
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "h3",
                        style: {"width":"50%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"30%"}
                      })
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (!_unref(companyStore).companies.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_component_el_empty, { description: "暂无公司信息" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: openAddDialog
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode(" 添加公司 ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).companies, (company) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: company.id,
                      class: "company-item"
                    }, [
                      _createElementVNode("div", {
                        class: "company-main",
                        onClick: ($event: any) => (handleCompanyClick(company))
                      }, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_el_avatar, {
                              size: 48,
                              src: company.logo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(company.name?.charAt(0)), 1)
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, _toDisplayString(company.name), 1),
                            _createElementVNode("div", _hoisted_42, [
                              (company.location)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Location))
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(company.location), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (company.industry)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Office))
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(company.industry), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ], 8, _hoisted_37),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_company_status_tag, {
                            status: company.status
                          }, null, 8, ["status"]),
                          (companyInterviewStatus.value.get(company.id as number)?.status)
                            ? (_openBlock(), _createBlock(_component_el_badge, {
                                key: 0,
                                value: companyInterviewStatus.value.get(company.id as number)?.status,
                                type: companyInterviewStatus.value.get(company.id as number)?.stage ? 
                  STAGE_TYPES[companyInterviewStatus.value.get(company.id as number)?.stage as keyof typeof STAGE_TYPES] : 
                  'info',
                                class: "interview-status-badge"
                              }, null, 8, ["value", "type"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", {
                            class: "icon-item",
                            onClick: ($event: any) => (handlePositionClick(company))
                          }, [
                            _createVNode(_component_el_icon, { class: "custom-icon position-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Suitcase))
                              ]),
                              _: 1
                            }),
                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "icon-label" }, "职位", -1))
                          ], 8, _hoisted_48),
                          _createElementVNode("div", {
                            class: "icon-item",
                            onClick: ($event: any) => (handleResourceClick(company))
                          }, [
                            _createVNode(_component_el_icon, { class: "custom-icon resource-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Files))
                              ]),
                              _: 1
                            }),
                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "icon-label" }, "资源", -1))
                          ], 8, _hoisted_49),
                          _createElementVNode("div", {
                            class: "icon-item",
                            onClick: ($event: any) => (handleInterviewClick(company))
                          }, [
                            _createVNode(_component_el_icon, { class: "custom-icon interview-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Calendar))
                              ]),
                              _: 1
                            }),
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "icon-label" }, "面试", -1))
                          ], 8, _hoisted_50)
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_pagination, {
                      "current-page": _unref(companyStore).page,
                      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(companyStore).page) = $event)),
                      "page-size": _unref(companyStore).size,
                      "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_unref(companyStore).size) = $event)),
                      total: _unref(companyStore).total,
                      "page-sizes": [10, 20, 50, 100],
                      layout: "total, sizes, prev, pager, next",
                      onSizeChange: handleSizeChange,
                      onCurrentChange: handlePageChange
                    }, null, 8, ["current-page", "page-size", "total"])
                  ])
                ]))
        ])),
    _createVNode(_component_el_dialog, {
      modelValue: addDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addDialogVisible).value = $event)),
      title: "添加公司",
      width: "600px",
      "close-on-click-modal": false,
      "destroy-on-close": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (addDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitAddForm,
            loading: _unref(companyStore).loading
          }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [
              _createTextVNode(" 保存 ")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(CompanyForm, {
          ref_key: "addFormRef",
          ref: addFormRef,
          loading: _unref(companyStore).loading,
          onSubmit: handleAddCompany
        }, null, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})